import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=136d1d6f"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports